import service from "./request";
import service_b from "./request_book";

export function getMoviesMain(params) {
  return service.get("/api/MovieMain", { params: params });
}

export function getAllMovies(params) {
  return service.get("/api/Movies", { params: params });
}

export function getMovieEpisodes(params) {
  return service.get("/api/MovieEpisodes/GetByMovieId", { params: params });
}

export function getMovieCategories(params) {
  return service.get("/api/MovieCategories", { params: params });
}
export function getByCategories(params) {
  return service.get("/api/Movies/GetByCategories", { params: params });
}

export function getReComMovies(params) {
  return service.get("/api/Movies/RecommendationsFor", { params: params });
}

export function ReportMediaEvents(data) {
  return service.post("/api/Report/ReportMediaEvents", data);
}

// 小说接口
export function getNovelControllers() {
  return service_b.get("/v1/api/NovelControllers");
}

export function getNovelDetails(id, params) {
  return service_b.get(`/v1/api/NovelChapter/chapter/${id}`, {
    params: params,
  });
}

export function getChapterDetails(id) {
  return service_b.get(`/v1/api/NovelChapter/chapter-no/${id}`);
}
